import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ug-bachelor-of-commerce',
  templateUrl: './ug-bachelor-of-commerce.component.html',
  styleUrls: ['./ug-bachelor-of-commerce.component.scss']
})
export class UgBachelorOfCommerceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
